import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'maplibre-gl/dist/maplibre-gl.css'
import './styles/tokens.css'
import './styles/global.css'
import App from './App.vue'
import { i18n } from './i18n'
import { router } from './router'

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .mount('#app')
